// 电影模拟数据（前端静态演示，无真实播放能力）
export const movies = [
  {
    id: "m-deepsea-light",
    title: "深海追光",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20sci-fi%20movie%20poster%20showing%20a%20glowing%20light%20beam%20piercing%20through%20deep%20blue%20ocean%20trenches%2C%20minimalist%20geometric%20composition%2C%20cinematic%20teal%20and%20gold%20gradient%2C%20dramatic%20atmospheric%20mood%2C%20no%20text%2C%20high%20detail%20digital%20illustration%20with%20soft%20grain%20texture&width=400&height=600&seq=movie-deepsea-light-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20abstract%20underwater%20scene%20with%20a%20vertical%20shaft%20of%20light%20cutting%20through%20dark%20ocean%20layers%2C%20stylized%20artistic%20rendering%2C%20deep%20blue%20to%20gold%20gradient%2C%20soft%20particles%2C%20moody%20atmospheric%20lighting%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-deepsea-light-hero&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻", "冒险", "剧情"],
    rating: 8.6,
    duration: "132分钟",
    director: "陈默",
    actors: ["林嘉树", "周予安", "苏黎"],
    tagline: "在最深的地方，遇见最亮的光。",
    synopsis: "一支深海科考队在万米海沟发现了一处违背物理法则的发光区域。随着探索深入，队员们逐渐发现，那道光的来源与人类文明的起源有着隐秘联系。面对未知与恐惧，他们必须在真相与生存之间做出选择。",
    tags: ["深海", "硬科幻", "悬疑"],
  },
  {
    id: "m-fog-city",
    title: "迷雾之城",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20thriller%20movie%20poster%20depicting%20a%20misty%20city%20skyline%20dissolving%20into%20fog%20layers%2C%20geometric%20shapes%2C%20cool%20steel%20grey%20and%20amber%20accents%2C%20minimal%20composition%2C%20suspenseful%20atmosphere%2C%20no%20text%2C%20high%20detail%20digital%20illustration&width=400&height=600&seq=movie-fog-city-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20abstract%20foggy%20metropolis%20silhouette%20with%20layered%20mist%20and%20faint%20amber%20street%20glow%2C%20stylized%20artistic%20rendering%2C%20cool%20grey%20palette%2C%20moody%20noir%20atmosphere%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-fog-city-hero&orientation=landscape",
    year: 2023,
    region: "美国",
    genres: ["悬疑", "惊悚", "犯罪"],
    rating: 8.2,
    duration: "118分钟",
    director: "Ethan Cole",
    actors: ["Marcus Reed", "Elena Ford", "David Lin"],
    tagline: "真相藏在看不见的地方。",
    synopsis: "连续失踪案让整座城市笼罩在迷雾之中。一名执着的老刑警与年轻的侧写师被迫合作，他们发现每一条线索都指向同一个被刻意抹去的名字。当雾气散去，真相比想象中更加危险。",
    tags: ["犯罪", "烧脑", "反转"],
  },
  {
    id: "m-cloud-forest",
    title: "云上森林",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20animated%20fantasy%20movie%20poster%20with%20floating%20islands%20above%20a%20sea%20of%20clouds%2C%20lush%20green%20canopy%2C%20soft%20pastel%20sky%2C%20whimsical%20minimal%20composition%2C%20warm%20sunlight%20rays%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=movie-cloud-forest-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20fantasy%20landscape%20with%20floating%20green%20islands%20above%20a%20golden%20sea%20of%20clouds%2C%20soft%20pastel%20gradient%20sky%2C%20whimsical%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-cloud-forest-hero&orientation=landscape",
    year: 2024,
    region: "日本",
    genres: ["动画", "奇幻", "家庭"],
    rating: 9.0,
    duration: "104分钟",
    director: "宫本遥",
    actors: ["花泽未央", "佐藤健一", "小林优"],
    tagline: "有些地方，只有相信才会抵达。",
    synopsis: "少女在祖父的旧日记里发现了一座漂浮在云海之上的森林。为了寻找失踪多年的祖父，她踏上了一场跨越天空的旅程，并在途中学会了告别与成长。",
    tags: ["治愈", "画面美", "合家欢"],
  },
  {
    id: "m-homebound-train",
    title: "归途列车",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20warm%20drama%20movie%20poster%20showing%20a%20lone%20train%20crossing%20a%20vast%20golden%20field%20at%20dusk%2C%20minimal%20horizon%20line%2C%20muted%20earth%20tones%2C%20nostalgic%20atmosphere%2C%20no%20text%2C%20high%20detail%20digital%20illustration&width=400&height=600&seq=movie-homebound-train-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20warm%20countryside%20scene%20with%20a%20train%20crossing%20golden%20fields%20under%20a%20soft%20sunset%20sky%2C%20muted%20earth%20palette%2C%20nostalgic%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-homebound-train-hero&orientation=landscape",
    year: 2022,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.8,
    duration: "126分钟",
    director: "李望",
    actors: ["王志远", "刘淑芬", "赵一鸣"],
    tagline: "回家的路，走了很多年。",
    synopsis: "一名在外打拼多年的中年人，带着年迈的母亲踏上一趟慢速列车回乡。漫长的旅途中，母子俩重新打开了被时间封存的话题，也重新认识了彼此。",
    tags: ["亲情", "慢节奏", "走心"],
  },
  {
    id: "m-night-guard",
    title: "暗夜守卫",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20action%20thriller%20movie%20poster%20with%20a%20silhouetted%20figure%20against%20a%20glowing%20night%20city%2C%20sharp%20geometric%20shapes%2C%20dark%20indigo%20and%20electric%20teal%20accents%2C%20high%20contrast%20minimal%20composition%2C%20no%20text%2C%20digital%20illustration&width=400&height=600&seq=movie-night-guard-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20night%20cityscape%20with%20glowing%20teal%20lights%20and%20rain%20streaks%2C%20dramatic%20high%20contrast%20artistic%20rendering%2C%20dark%20indigo%20palette%2C%20moody%20atmosphere%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-night-guard-hero&orientation=landscape",
    year: 2023,
    region: "英国",
    genres: ["动作", "犯罪", "惊悚"],
    rating: 7.9,
    duration: "115分钟",
    director: "Owen Blake",
    actors: ["Liam Carter", "Sophie Hale", "Noah Grant"],
    tagline: "夜幕之下，无人退缩。",
    synopsis: "一名退役特工被迫重返黑夜。他要在一夜之间阻止一场针对城市的阴谋，而时间正一分一秒地流逝。",
    tags: ["高燃", "动作", "节奏快"],
  },
  {
    id: "m-time-window",
    title: "时序之窗",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20romantic%20sci-fi%20movie%20poster%20with%20a%20glowing%20circular%20portal%20and%20two%20distant%20silhouettes%2C%20soft%20violet%20rose%20and%20warm%20amber%20gradient%2C%20minimal%20elegant%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=movie-time-window-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20scene%20of%20a%20glowing%20time%20portal%20in%20a%20vast%20dim%20space%2C%20soft%20violet%20and%20amber%20gradient%20light%2C%20elegant%20artistic%20rendering%2C%20dreamy%20atmosphere%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-time-window-hero&orientation=landscape",
    year: 2024,
    region: "法国",
    genres: ["科幻", "爱情", "剧情"],
    rating: 8.4,
    duration: "121分钟",
    director: "Camille Laurent",
    actors: ["Élodie Martin", "Julien Rossi", "Nina Petit"],
    tagline: "如果时间可以重来一次。",
    synopsis: "一位物理学家发明了可以窥视过去的装置。为了阻止一场遗憾，她一次次打开时序之窗，却发现每次改变都在悄悄重塑当下。",
    tags: ["浪漫", "时间", "细腻"],
  },
  {
    id: "m-mountain-sea",
    title: "山海异闻",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20chinese%20fantasy%20movie%20poster%20with%20misty%20mountains%20and%20a%20mythical%20beast%20silhouette%2C%20ink%20wash%20style%2C%20deep%20jade%20and%20gold%20accents%2C%20minimal%20elegant%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=movie-mountain-sea-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20oriental%20fantasy%20landscape%20with%20misty%20layered%20mountains%20and%20golden%20clouds%2C%20ink%20wash%20artistic%20rendering%2C%20deep%20jade%20palette%2C%20mystical%20atmosphere%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-mountain-sea-hero&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["奇幻", "古装", "冒险"],
    rating: 8.1,
    duration: "137分钟",
    director: "陆之南",
    actors: ["顾青", "白薇", "江野"],
    tagline: "山海之间，皆有其名。",
    synopsis: "少年画师意外获得一本会自己写字的《山海异闻录》，从此被卷入人与异兽共存的世界。他必须找到传说中的山海门，才能阻止一场浩劫。",
    tags: ["国风", "特效", "奇幻"],
  },
  {
    id: "m-dune-echo",
    title: "沙丘回响",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20epic%20sci-fi%20movie%20poster%20with%20towering%20sand%20dunes%20under%20a%20giant%20pale%20sun%2C%20lone%20figure%20silhouette%2C%20warm%20ochre%20and%20haze%20palette%2C%20minimal%20monumental%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=movie-dune-echo-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20epic%20desert%20landscape%20with%20massive%20dunes%20and%20a%20hazy%20amber%20sky%2C%20monumental%20artistic%20rendering%2C%20warm%20ochre%20palette%2C%20dramatic%20atmosphere%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-dune-echo-hero&orientation=landscape",
    year: 2021,
    region: "美国",
    genres: ["科幻", "史诗", "冒险"],
    rating: 8.7,
    duration: "155分钟",
    director: "Derek Nolan",
    actors: ["Adam Cross", "Mira Vega", "Tomas Bale"],
    tagline: "沙会记得一切。",
    synopsis: "在资源枯竭的遥远星球上，一个年轻继承者被迫直面命运。他要带领族群穿越无尽的沙海，寻找属于他们的未来。",
    tags: ["史诗", "大场面", "科幻"],
  },
  {
    id: "m-silent-confession",
    title: "无声告白",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20korean%20drama%20thriller%20movie%20poster%20with%20a%20single%20rainy%20window%20and%20a%20blurred%20figure%20reflection%2C%20muted%20grey%20and%20cold%20teal%20palette%2C%20minimal%20melancholic%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=movie-silent-confession-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20rainy%20city%20street%20at%20night%20with%20reflection%20on%20wet%20asphalt%2C%20muted%20grey%20and%20teal%20palette%2C%20melancholic%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-silent-confession-hero&orientation=landscape",
    year: 2022,
    region: "韩国",
    genres: ["剧情", "悬疑"],
    rating: 8.5,
    duration: "113分钟",
    director: "Park Ji-hoon",
    actors: ["Kim Da-eun", "Lee Jun-seo", "Han So-mi"],
    tagline: "有些话，说不出口才最响。",
    synopsis: "一位听力受损的少女成为一桩旧案唯一的目击者。她用画笔一点点拼凑出记忆，也让被掩埋的真相重新浮出水面。",
    tags: ["细腻", "悬疑", "催泪"],
  },
  {
    id: "m-aurora-op",
    title: "极光行动",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20adventure%20movie%20poster%20with%20green%20aurora%20over%20icy%20mountains%2C%20tiny%20expedition%20figures%2C%20cool%20cyan%20and%20deep%20blue%20palette%2C%20minimal%20vast%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=movie-aurora-op-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20arctic%20landscape%20with%20green%20aurora%20and%20snow%20mountains%2C%20cool%20cyan%20and%20deep%20blue%20palette%2C%20vast%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-aurora-op-hero&orientation=landscape",
    year: 2024,
    region: "挪威",
    genres: ["冒险", "剧情"],
    rating: 7.8,
    duration: "108分钟",
    director: "Lars Berg",
    actors: ["Ingrid Holm", "Sven Aas", "Maja Lund"],
    tagline: "向着极光，走下去。",
    synopsis: "一支极地科考队在暴风雪中失去联系。留守站的年轻队员独自踏上搜救之路，在极夜与极光之间，她学会了与孤独相处。",
    tags: ["极地", "冒险", "生存"],
  },
  {
    id: "m-city-glimmer",
    title: "城市微光",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20urban%20drama%20movie%20poster%20with%20warm%20window%20lights%20of%20apartment%20buildings%20at%20night%2C%20soft%20amber%20and%20navy%20palette%2C%20minimal%20cozy%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=movie-city-glimmer-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20city%20street%20at%20dusk%20with%20warm%20window%20lights%20and%20soft%20bokeh%2C%20amber%20and%20navy%20palette%2C%20cozy%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-city-glimmer-hero&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "都市"],
    rating: 8.3,
    duration: "119分钟",
    director: "许清",
    actors: ["程野", "苏念", "何舟"],
    tagline: "每扇窗后，都有一个故事。",
    synopsis: "深夜便利店、末班地铁、天台上的烟花——三个看似无关的都市人，因为一个丢失的笔记本产生了交集，也各自找到了继续走下去的理由。",
    tags: ["都市", "群像", "温暖"],
  },
  {
    id: "m-secret-guardian",
    title: "秘境守护者",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Stylized%20fantasy%20adventure%20movie%20poster%20with%20a%20hidden%20emerald%20valley%20and%20a%20mysterious%20guardian%20silhouette%2C%20lush%20green%20and%20mist%20palette%2C%20minimal%20epic%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=400&height=600&seq=movie-secret-guardian-poster&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20stylized%20hidden%20emerald%20valley%20with%20waterfalls%20and%20morning%20mist%2C%20lush%20green%20palette%2C%20epic%20artistic%20rendering%2C%20no%20text%2C%20editorial%20key%20art&width=1600&height=900&seq=movie-secret-guardian-hero&orientation=landscape",
    year: 2024,
    region: "新西兰",
    genres: ["冒险", "奇幻", "家庭"],
    rating: 8.0,
    duration: "112分钟",
    director: "Tane Whitiora",
    actors: ["Ruby King", "Mana Tui", "Jack Salmon"],
    tagline: "守护，是一种选择。",
    synopsis: "两兄妹在祖父的农场后山发现了一片被迷雾守护的秘境。他们必须在秘境消失之前，学会成为它新的守护者。",
    tags: ["冒险", "自然", "合家欢"],
  },
];